import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_HREF } from "@/lib/site";

export default function StickyQuoteBar() {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-ink text-bone flex" data-testid="sticky-quote-bar">
      <a
        href={PHONE_HREF}
        data-testid="sticky-call-button"
        className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-medium border-r border-bone/15"
      >
        <Phone size={16} /> Call us
      </a>
      <Link to="/quote" data-testid="sticky-get-quote-button" className="flex-1 flex items-center justify-center py-4 text-sm font-semibold bg-terracotta text-white">
        Get a Quote
      </Link>
    </div>
  );
}
